// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "-legacy." + {"45":"e2969e68","265":"5bf259f9","297":"4a803fd7","643":"02f0d56f"}[chunkId] + ".js";
};